// extracted by mini-css-extract-plugin
export default {"settings-title":"styles_settings-title__tjhVm"};